export default from './Splash'


// WEBPACK FOOTER //
// ./src/components/Splash/index.js